<template>
  <div class="container-fluid bg-white py-3">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h4>Account Details</h4>
        </div>
        <div class="col-12">
          <notifications />
          <form
            autocomplete="nope"
            @submit.prevent="updateAccount"
          >
            <div class="form-group row">
              <div class="col-md-6">
                <label>Name</label>
                <input
                  v-model="name"
                  class="form-control"
                  type="text"
                  required
                >
              </div>
              <div class="col-md-6">
                <label>Email</label>
                <input
                  v-model="email"
                  class="form-control"
                  type="email"
                  required
                >
              </div>
            </div>
            <div
              v-if="type == 'food_service_full' || type == 'food_service_limited'"
              class="form-group row"
            >
              <div class="col-md-6">
                <label>Address</label>
                <input
                  v-model="meta.address"
                  class="form-control"
                  type="text"
                  :required="type === 'food_service_full' || type === 'food_service_limited' ? true : false "
                >
              </div>
              <div class="col-md-6">
                <label>Facility Name</label>
                <input
                  v-model="meta.facility_name"
                  class="form-control"
                  type="text"
                >
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-6">
                <label>Password</label>
                <input
                  ref="password"
                  v-model="password"
                  class="form-control"
                  :type="showPassword ? 'text' : 'password'"
                  autocomplete="new-password"
                  data-lpignore="true"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                >
                <span
                  :class="['fa fa-fw field-icon text-muted', eyeIconStatePassword]"
                  @click="togglePasswordVisibility"
                />
              </div>
              <div class="col-md-6">
                <label>Confirm Password</label>
                <input
                  ref="password_confirm"
                  v-model="password_confirmation"
                  class="form-control"
                  :type="showPasswordConfirmation ? 'text' : 'password'"
                  autocomplete="new-password"
                  data-lpignore="true"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                >
                <span
                  :class="['fa fa-fw field-icon text-muted', eyeIconStatePasswordConfirmation]"
                  @click="togglePasswordConfirmationVisibility"
                />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-6">
                <button
                  type="submit"
                  class="btn btn-primary"
                >
                  Update Account
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <hr>
      <div
        v-if="type == 'professional'"
        class="row"
      >
        <div class="col-md-12">
          <h4>Cancel Account</h4>
        </div>
        <div class="col-md-12">
          <p>Please contact your Food Fitness First, Inc.® representative to close your Professional account.</p>
        </div>
      </div>
      <div
        v-if="type != 'professional'"
        class="row"
      >
        <div class="col-md-12">
          <h4>Cancel Account</h4>
        </div>
        <div class="col-md-12">
          <p>Cancelling your account will immediately cancel your subscription without a refund and remove all access to FoodFitnessFirst.com.  You will also lose all your saved health data.</p>
        </div>
      </div>
      <modal
        v-if="type != 'professional'"
        ref="cancelModal"
        title="Are you sure?"
        button_text="Cancel Account"
        button_classes="btn cancel-btn"
        title_classes="title-red"
      >
        <p class="cancellation-text">
          Are you sure? Cancelling your account will immediately cancel your subscription without a refund and remove all access to FoodFitnessFirst.com. You will also lose all your saved health data.
        </p>
        <hr>
        <div class="d-flex justify-content-end">
          <div
            class="btn btn-danger"
            @click="cancelAccount"
          >
            Cancel Account
          </div>
          <div
            class="btn btn-default btn-outline-dark ml-2"
            @click="$refs.cancelModal.toggle()"
          >
            Close
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>

import Modal from '../components/Modal.vue';

export default {
  components: {
    Modal,
  },
  data () {
    return {
      email: '',
      name:'',
      meta: {},
      type: '',
      password: null,
      showPassword: false,
      password_confirmation: null,
      showPasswordConfirmation: false,
    }
  },
  computed: {
    eyeIconStatePassword(){
      return this.showPassword ? 'fa-eye-slash' : 'fa-eye';
    },
    eyeIconStatePasswordConfirmation(){
      return this.showPasswordConfirmation ? 'fa-eye-slash' : 'fa-eye';
    },
  },
  mounted(){
    this.name = this.$store.state.user.user.name;
    this.email = this.$store.state.user.user.email;
    this.meta.address = this.$store.state.user.user.meta.address;
    this.meta.facility_name = this.$store.state.user.user.meta.facility_name;
    this.type = this.$store.state.user.user.type;
  },
  methods: {
    updateAccount () {
      let data = {
        email: this.email,
        name: this.name,
        meta: this.meta
      };

      if (this.password) {
        data.password = this.password;
        data.password_confirmation = this.password_confirmation;
      }

      this.$store.dispatch('user/updateUser', data).then(res => {
        this.password = null;
        this.password_confirmation = null;
        this.$refs.password.setAttribute('readonly', true);
        this.$refs.password_confirm.setAttribute('readonly', true);

        this.$store.dispatch('notifications/setSuccess', 'Your account has been updated')
      }).catch(err => {
        this.$store.dispatch('notifications/setError', err.response.data.message || null);
        this.$store.dispatch('notifications/setErrorBag',err.response.data.errors || null);
      })
    },
    cancelAccount () {

      this.$refs.cancelModal.toggle();

      this.$store.dispatch('user/cancelAccount').then(() => {
        this.$router.push({name: 'login'});
        this.$store.dispatch('notifications/setSuccess', 'Account deleted.');
      }).catch((err) => {
        this.$store.dispatch('notifications/setError', 'Error Deleting Account');
      })
    },
    togglePasswordVisibility(){
      this.showPassword = !this.showPassword;
    },
    togglePasswordConfirmationVisibility(){
      this.showPasswordConfirmation = !this.showPasswordConfirmation;
    }
  }
}
</script>
<style lang="scss" scoped>
    .field-icon {
        float: right;
        margin-right: 9px;
        margin-top: -27px;
        position: relative;
        z-index: 2;
    }
    .cancellation-text {
        max-width: 500px;
    }
</style>
